//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
let d=[[[0,"ExportType",1,0]],[[["dataTypeToExport","maxSearchLevels"],"DryRun",{},2,0],[["xmlFileName","dataTypeToExport","maxSearchLevels"],"ExportToFile",{},3,0],[["itemIDRev","dataTypeToExport","maxSearchLevels"],"ExportToTeamcenter",{},3,0]],[]];
SPLM.MechanicalRouting.CablewayExportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.CablewayExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.CablewayExportBuilder.ExportMode = Object.freeze({
    "Native" : "Native", "Teamcenter" : "Teamcenter"});

export default SPLM;